export default "__VITE_ASSET__C9wRxEkT__"